import Vue from "vue";
import VueRouter from "vue-router";
import {
  getUser,
  setUserAuthOfCode,
  setUserOfCodeWxDev,
  setUserOfCodeWxPrd,
} from "@/scripts/userAuth";
import { getWechatEnv } from "@/utils/utils";

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_PATH || "",
  mode: "history",
  scrollBehavior(_to, _from, _savedPosition) {
    return _savedPosition || { x: 0, y: 0 };
  },
  routes: [],
});

// 向router.meta中注入key-value
const injectFlagToRouter = function(router, key, value) {
  router.meta = router.meta || {};
  router.meta[key] = value;
  if (router.children) {
    router.children.map((child) => {
      child.meta[key] = value;
    });
  }
};

/**
 * 自动集合views下模块路由配置
 */
const setRoute = function() {
  const requireRouter =
    process.env.VUE_APP_PROJ === "audi"
      ? require.context("@/views/vSearch", true, /route\.js$/)
      : require.context("@/views", true, /route\.js$/);
  requireRouter.keys().forEach((fileName) => {
    const routerConfig = requireRouter(fileName); // fileName为文件路径名
    if (routerConfig.default) {
      // 动态添加路由
      if (
        process.env.VUE_APP_PROJ !== "audi" &&
        !Array.isArray(routerConfig.default)
      ) {
        injectFlagToRouter(
          routerConfig.default,
          "module",
          fileName.replace(/\.\/(.*)\/route\.js/, "$1")
        );
        router.addRoute(routerConfig.default);
        router.options.routes.push(routerConfig.default);
      }
      if (
        process.env.VUE_APP_PROJ !== "audi" &&
        Array.isArray(routerConfig.default)
      ) {
        routerConfig.default.forEach((item) => {
          injectFlagToRouter(
            item,
            "module",
            fileName.replace(/\.\/(.*)\/route\.js/, "$1")
          );
          router.addRoute(item);
          router.options.routes.push(item);
        });
      }
      if (process.env.VUE_APP_PROJ === "audi") {
        router.addRoute(routerConfig.default);
        router.options.routes.push(routerConfig.default);
      }
    }
  });
  const notFound = {
    path: "*",
    name: "notfound",
    component: () => import("@/components/404"),
  };
  router.addRoute(notFound);
  router.options.routes.push(notFound);
};

setRoute();

router.beforeEach(async (to, _from, next) => {
  const moduleName = to.meta.module;
  global.APP_CONFIG.tenantId = to.params.tenant || 120000;
  if (moduleName) {
    require(`@/views/${moduleName}/constant.js`);
  }
  document.title = to.meta.routeName || "";
  if (
    process.env.VUE_APP_PROJ === "tsmbu" &&
    process.env.VUE_APP_FORK !== "true"
  ) {
    // 可复制化且非交付项目，使用公共的自建应用信息
    global.APP_CONFIG.corpId = "ww754a162f2fe3481f";
    if (process.env.VUE_APP_ENV === "test") {
      global.APP_CONFIG.appId = 1000127;
    } else if (process.env.VUE_APP_ENV === "uat") {
      global.APP_CONFIG.appId = 1000127;
    } else if (process.env.VUE_APP_ENV === "prod") {
      global.APP_CONFIG.appId = 1000126;
    }
  }
  if (!to.meta.unGetUser) {
    await getUser();
  } else {
    const channel = getWechatEnv(); // 企微1 微信2 其它3
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let corpId; // 企业id
    let taskAppId; // 任务
    let speechAppId; // 话术
    let materialAppId; // 任务
    if (process.env.VUE_APP_ENV !== "prod") {
      // 测试
      corpId = "wwb98888b56e568b9e";
      taskAppId = "1000003";
      speechAppId = "1000004";
      materialAppId = "1000002";
    } else {
      // 生产
      corpId = "ww84ef592306da07b3";
      taskAppId = "1000078";
      speechAppId = "1000079";
      materialAppId = "1000079";
    }
    if (channel === 1) {
      // 企微 没有登录信息 初始化登录接口
      if (!userInfo) {
        // 任务中心、话术库、素材库
        if (to.name === "task") {
          const appId = taskAppId; // 应用id
          await setUserAuthOfCode({ corpId, appId });
        } else if (to.name === "speechbank") {
          const appId = speechAppId; // 应用id
          await setUserAuthOfCode({ corpId, appId });
        } else if (to.name === "material" || to.name === "workMaterial") {
          const appId = materialAppId; // 应用id
          await setUserAuthOfCode({ corpId, appId });
        } else if (to.name === "materialPreview") {
          const appId = materialAppId; // 应用id
          await setUserAuthOfCode({ corpId, appId });
        }
      }
    } else if (channel === 2) {
      // 微信 没有登录信息 初始化登录接口
      if (!userInfo) {
        if (to.name === "workMaterial" || to.name === "materialPreview") {
          if (process.env.VUE_APP_ENV !== "prod") {
            // 测试
            const appId = "wx235b2abcc8c160dc";
            await setUserOfCodeWxDev({ corpId, appId });
          } else {
            // 生产
            const appId = "wxb97785cbb0849e5f";
            await setUserOfCodeWxPrd({ corpId, appId });
          }
        }
      }
    }
  }
  next();
});

export default router;
